// CountdownTimer.js
import React, { useEffect, useState} from 'react';
import Countdown from 'react-countdown';
import { View,Text, TouchableOpacity } from "react-native";
  import { CreateResponsiveStyle } from "rn-responsive-styles";
const Timer = ({ requestOtp, isShowOtpScreen,onClickGetOtp,counterRef,screenType  }) => {
 
    const styles = useStyles();
  const [timerState, setTimeState] = useState({
    times: [
      Date.now() + 5000,
      Date.now() + 12000,
      Date.now() + 17000,
      Date.now() + 22000,
    ],
    currentTimeIndex: 0,
    currentTime: Date.now() + 10,
  });

  const completeTime = () => {
    if (
      timerState.times.length - 1 <=
      timerState.times.indexOf(timerState.currentTime)
    )
      return;
    // move to next time
    timerState.currentTimeIndex++;
    timerState.currentTime = new Date(
      timerState.times[timerState.currentTimeIndex + 1]
    );
  };

  const timerRenderer = ({ hours, minutes, seconds, completed, api }) => {
    if (completed || isNaN(minutes)) {
      return ( <Text>{"00:00"}</Text>);
    } else {
      return (
          <Text style = {styles.timerTextStyle}>
            {minutes}:{seconds}
          </Text>
      );
    };
  }
  useEffect(() => {
    if (requestOtp)
      setTimeState({
        times: [
          Date.now() + 5000,
          Date.now() + 12000,
          Date.now() + 17000,
          Date.now() + 22000,
        ],
        currentTimeIndex: 0,
        currentTime: Date.now() + 60000,
      })
  }, [requestOtp, isShowOtpScreen])

  return (
    <View style = {styles.circle}>
<Countdown
    ref={counterRef}
    date={timerState.currentTime}
    key={timerState.currentTimeIndex}
    onComplete={completeTime}
    intervalDelay={0}
    precision={3}
    renderer={timerRenderer}
    />
    </View>
    
  );
};

export default Timer;
// DownloadTimer.js
export const DownloadTimer = ({ duration = 60000 }) => {
  const styles = useStyles();
  const [endTime, setEndTime] = useState(Date.now() + duration);

  useEffect(() => {
    setEndTime(Date.now() + duration);
  }, [duration]);

  const renderer = ({ minutes, seconds, completed }) => {
    if (completed) {
      return <Text style={styles.timerTextStyle}>00:00</Text>;
    }
    return (
      <Text style={styles.timerTextStyle}>
        {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
      </Text>
    );
  };

  return (
    <View style={styles.circle}>
      <Countdown
        date={endTime}
        renderer={renderer}
      />
    </View>
  );
};

const useStyles = CreateResponsiveStyle({
  timerTextStyle: {
    fontFamily: 'Inter',
    fontSize: 17,
    marginTop: 20,
  },
  circle: {
    width: 70,
    height: 70,
    borderWidth: 3,
    borderColor: '#9C1D25',
    borderRadius: 50,
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 15,
  },
  timerTextStyle: {
    fontFamily: "Inter",
    fontSize: 17,
    marginTop : 20
  },
  resendTextStyle: {
    fontFamily: "Inter",
    fontSize: 20,
    lineHeight: 15,
    letterSpacing: 0,
    color: "#bd2d37",
  },

});
